
require("../../../../LabelledElement/LabelledElement.st.css.js");
require("../../Foundations/colors.st.css.js");
const { classesRuntime, statesRuntime } = require("./../../../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_177_0_BrandLabelledElement";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_177_0_BrandLabelledElement__root","label":"wds_1_177_0_LabelledElement__label","labelText":"wds_1_177_0_LabelledElement__labelText"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {}; 
module.exports.vars = {}; 




